export const getQuestions = action => (action.component ? action.component : 'questions');

export const hasVariationsPickers = state => state.components.variations.pickers?.length > 0;

export const hasAnyPickers = (state, any) => state.components[any].pickers?.length > 0;

export const hasVisibleVariations = state =>
  state.components.variations?.state === 'VISIBLE' ? 'variations' : 'outside_variations';
